module.exports = __webpack_public_path__ + "img/companyIntro4.6afd39f4.png";